import React from 'react'
export const sidebarMenuItems = ['dashboard', 'users', 'language']

export const menuItems = {
  dashboard: {
    icon: <i className='bi bi-house' />,
    name: 'Dashboard',
    url: 'dashboard'
  },
  users: {
    icon: <i className='bi bi-people' />,
    name: 'Users',
    url: 'users',
    sysAdminCheck: true
  },
  language: {
    icon: <i className='bi bi-shield-lock' />,
    name: 'Language',
    subItems: [
      {
        name: 'German',
        url: 'language/de'
      },
      {
        name: 'English',
        url: 'language/en'
      }
    ]
  }
}
